import { useCategory } from "../../../fetch/fetch.category.ts";
import ErrMessage from "../../core/ErrMessage.tsx";
import { EMPTY_CATEGORY } from "../../../const/typeDefault/Category.ts";
import { CategoryType } from "../../../types/Category.ts";
import { ReactNode } from "react";

const CategoryFetch = ({
  slug,
  children,
  fallback,
}: {
  slug: string;
  children?: (ids: CategoryType) => ReactNode;
  fallback: ReactNode;
}) => {
  const { category, isLoading, isError } = useCategory(slug, EMPTY_CATEGORY);
  if (isLoading) return fallback;
  if (isError) return <ErrMessage message={isError} />;
  if (!children) return null;
  return children(category);
};
export default CategoryFetch;
